import axios from 'axios';
import { useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  MANAGE_SUBS_UPLOAD_GROUPS_BEGIN,
  MANAGE_SUBS_UPLOAD_GROUPS_SUCCESS,
  MANAGE_SUBS_UPLOAD_GROUPS_FAILURE,
  MANAGE_SUBS_UPLOAD_GROUPS_DISMISS_ERROR,
} from './constants';
import { EXPORT_BOS_API_REQUEST_URL } from '../../../common/apiConfig';
export function uploadGroups(args = {}) {
  return (dispatch,getState) => { // optionally you can have getState as the second argument
    dispatch({
      type: MANAGE_SUBS_UPLOAD_GROUPS_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      const user = getState().home.auth.user;
      const params = {
        userId: user.userId,
        emailId: user.email,
        userName: user.userName,
      }
      const doRequest = axios({
        url: `${EXPORT_BOS_API_REQUEST_URL}/groupsBulkUpload`,
        method: 'post',
        params,
        data: args,
        headers: { "content-type": "multipart/form-data" },
      });
      doRequest.then(
        (res) => {
          dispatch({
            type: MANAGE_SUBS_UPLOAD_GROUPS_SUCCESS,
            data: res,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          const errorMsg = err && err.response ? err.response.data.message : 'There is an error. Please refresh page or contact administrator.';
          dispatch({
            type: MANAGE_SUBS_UPLOAD_GROUPS_FAILURE,
            data: { error: errorMsg },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissUploadGroupsError() {
  return {
    type: MANAGE_SUBS_UPLOAD_GROUPS_DISMISS_ERROR,
  };
}

export function useUploadGroups() {
  const dispatch = useDispatch();

  const { uploadGroupsPending, uploadGroupsError } = useSelector(
    state => ({
      uploadGroupsPending: state.manageSubs.uploadGroupsPending,
      uploadGroupsError: state.manageSubs.uploadGroupsError,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(uploadGroups(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissUploadGroupsError());
  }, [dispatch]);

  return {
    uploadGroups: boundAction,
    uploadGroupsPending,
    uploadGroupsError,
    dismissUploadGroupsError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case MANAGE_SUBS_UPLOAD_GROUPS_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        uploadGroupsPending: true,
        uploadGroupsError: null,
      };

    case MANAGE_SUBS_UPLOAD_GROUPS_SUCCESS:
      // The request is success
      return {
        ...state,
        uploadGroupsPending: false,
        uploadGroupsError: null,
      };

    case MANAGE_SUBS_UPLOAD_GROUPS_FAILURE:
      // The request is failed
      return {
        ...state,
        uploadGroupsPending: false,
        uploadGroupsError: action.data.error,
      };

    case MANAGE_SUBS_UPLOAD_GROUPS_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        uploadGroupsError: null,
      };

    default:
      return state;
  }
}
